import { Box, Grid, styled } from "components/common";
import productImage from "assets/images/apocalypse.svg";
import ProductDetailsLeftSide from "./product-details-left";
import ProductDetailMiddle from "./product-details-middle";
import ProductDetailsRight from "./product-details-right";
import useFunctions from "./ts/useFunctions";
import { useEffect } from "react";
import { ProductDetailsWrapper } from "./index.styled";
import ProductDetailsRecommendations from "./product-details-recommendations";
export default function ProductDetailxsain() {
  const { data, id, getProductDetails } = useFunctions();

  useEffect(() => {
    if (id) {
      getProductDetails();
    }
  }, [id]);

  return (
    <ProductDetailsWrapper>
      <Box className="product-details-main">
        <Grid container className="product-details-row">
          <Grid md={5} xs={12} className="product-details-right-left">
            <ProductDetailsLeftSide />
          </Grid>
          <Grid md={7} xs={12} className="product-details-right-mid">
            <ProductDetailMiddle />
          </Grid>
          {/* <Grid lg={3} md={3} xs={12} className="product-details-right-col">
          <ProductDetailsRight />
        </Grid> */}
        </Grid>
      </Box>
      <ProductDetailsRecommendations />
    </ProductDetailsWrapper>
  );
}
